import { Col, DatePicker, Input, InputNumber, Row } from 'antd'
import CIMSFormItem from 'components/CIMSFormItem'
import { HelpMessage } from 'utils/constants'

const Details: React.VFC = () => {
  const help = HelpMessage.Materials.Asphalt
  return (
    <>
      <Row gutter={16}>
        <Col flex={1}>
          <CIMSFormItem
            name="mixDesignNumber"
            requiredMessage="Please enter a Mix Design Number"
            label="Mix Design Number"
            help={help.MixID}
          >
            <Input />
          </CIMSFormItem>
        </Col>
        <Col flex={1}>
          <CIMSFormItem
            name="grade"
            label="Binder Grade"
            requiredMessage="Please enter a binder grade"
          >
            <Input />
          </CIMSFormItem>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col flex={1}>
          <CIMSFormItem
            name="supplier"
            label="Supplier"
            requiredMessage="Please enter a supplier"
            help={help.Supplier}
          >
            <Input />
          </CIMSFormItem>
        </Col>
        <Col flex={1}>
          <CIMSFormItem
            name="nominalSize"
            label="Nominal Size"
            requiredMessage="Please enter a nominal size"
          >
            <Input />
          </CIMSFormItem>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col flex={1}>
          <CIMSFormItem
            name="designBinderContent"
            label="Design Binder Content"
            requiredMessage="Please enter a design binder content"
          >
            <InputNumber style={{ width: '100%' }} />
          </CIMSFormItem>
        </Col>
        <Col flex={1}>
          <CIMSFormItem
            name="vma"
            label="VMA"
            requiredMessage="Please enter a VMA"
          >
            <InputNumber style={{ width: '100%' }} />
          </CIMSFormItem>
        </Col>
        <Col flex={1}>
          <CIMSFormItem
            name="theoMaxSpecGrav"
            label="Theoretical Max Specific Gravity"
            requiredMessage="Please enter a theoretical max specific gravity"
          >
            <InputNumber style={{ width: '100%' }} />
          </CIMSFormItem>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col flex={1}>
          <CIMSFormItem
            name="expirationDate"
            label="Expiration Date"
            requiredMessage="Please enter an expiration date"
          >
            <DatePicker style={{ width: '100%' }} allowClear />
          </CIMSFormItem>
        </Col>
      </Row>
    </>
  )
}

export default Details
